import { DashboardResponse } from '../types/dashboard';
import { ApiErrorResponse } from '../types/auth';
import { DASHBOARD_ENDPOINTS } from '../utils/endPoints';
import { createApiClient } from '../utils/axiosConfig';
import axios from 'axios';

const apiClient = createApiClient();

export const getDashboardStats = async (): Promise<DashboardResponse> => {
  try {
    const response = await apiClient.get<DashboardResponse>(DASHBOARD_ENDPOINTS.STATS);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const apiError = error.response.data as ApiErrorResponse;
      throw new Error(apiError.message || 'Failed to fetch dashboard stats');
    } else {
      console.error('Get dashboard stats service error:', error);
      throw new Error('An unexpected error occurred while fetching dashboard stats.');
    }
  }
};
